import React,{useEffect} from 'react';
import {connect} from "react-redux";
import {updateDataStore} from "src/actions/foundationActions";
//import {updateWebSocket} from "src/actions/websocketActions";
import store from 'src/store';
//import Train from './Train';
import {loadNewMod} from "../../../utilities/utilityFunctions";

const activitySpecs = {
    tfil:{position:"absolute",top:0,left:0,width:"100%",height:"100%",backgroundColor:"red"},
    trainLeft:{position:"absolute",bottom:0,left:0,width:"100%",height:150},
};

const activityMod = {
    "trainLeft":"components/TDP/Distractions/Train"
};

let defaultStyle={position:"absolute",top:0,left:0,width:0,height:0,backgroundColor:"transparent",display:"none"};

const DistractionPanel = (props) => {
    let stateData = store.getState();
    let distractionKey = stateData.currentActivityData.distractionKey;
    let calcStyle=activitySpecs.hasOwnProperty(distractionKey) ? activitySpecs[distractionKey] : defaultStyle;


    useEffect(()=>{
        if(activityMod.hasOwnProperty(distractionKey)){
            loadNewMod(activityMod[distractionKey],(mod)=>store.dispatch(updateDataStore({distractionModule:mod.default})));
        }
        else{
            store.dispatch(updateDataStore({distractionModule:null}))
        }
    },[distractionKey]);

    let mawd = stateData.dataStore.distractionModule ? <stateData.dataStore.distractionModule height={activitySpecs[distractionKey]?.height} runAnimation={props.currentActivityData.distractionPromptTime}/> :null;


    return <div id="distractionpanel">
        <div id="innerDistraction" style={calcStyle}>
            {mawd}
        </div>
    </div>
};

const mapStateToProps = (state) =>{
    return {
        currentActivityData:state.currentActivityData
    };
};

export default connect(mapStateToProps,{})(DistractionPanel);
